import { render, staticRenderFns } from "./_PendingDeploy.vue?vue&type=template&id=d0867f06"
import script from "./_PendingDeploy.vue?vue&type=script&lang=ts"
export * from "./_PendingDeploy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports